module.exports = __webpack_public_path__ + "static/04-ccd738c3fc97989cc4ca378f6cb920d0.png";